import { IStaticRangeOption } from 'components/molecules/FormDatePicker/DatePicker/types';

export const STATIC_DATE_RANGE_OPTIONS: Array<{
  label: string;
  value: IStaticRangeOption;
}> = [
  { label: 'To Date', value: 'to_date' },
  { label: 'Last 7 days', value: 'last_7' },
  { label: 'Last 15 days', value: 'last_15' },
  { label: 'Last 30 days', value: 'last_30' },
];

export const TWO_MONTHS_DATE_RANGE_OPTIONS: Array<{
  label: string;
  value: IStaticRangeOption;
}> = [
  { label: 'Today', value: 'today' },
  { label: 'Last 7 Days', value: 'last_7' },
  { label: 'Last 15 Days', value: 'last_15' },
  { label: 'Last 30 Days', value: 'last_30' },
  { label: 'This Month', value: 'this_month' },
  { label: 'Last Month', value: 'last_month' },
  { label: 'Custom', value: 'custom' },
];

export const PRIMARY_DATE_RANGE_OPTIONS: Array<{
  label: string;
  value: IStaticRangeOption;
}> = [
  { label: 'To Date', value: 'to_date' },
  { label: 'Next 7 Days', value: 'next_7' },
  { label: 'Next 15 Days', value: 'next_15' },
  { label: 'Next 30 Days', value: 'next_30' },
  { label: 'Next 90 Days', value: 'next_90' },
  { label: 'Last 7 Days', value: 'last_7' },
  { label: 'Last 15 days', value: 'last_15' },
  { label: 'Last 30 Days', value: 'last_30' },
];

export const DATE_FORMAT_MESSAGES = {
  YYYY_MM_DD: 'Date must be in yyyy-MM-dd format',
} as const;

export const DATE_FORMAT = {
  PRIMARY: 'dd/MM/yyyy', // Eg: 15/12/2025
  PRIMARY_TIME: 'dd/MM/yyyy, hh:mm a', // Eg: 15/12/2025, 12:00 PM
  PRIMARY_DAY: 'EEEE dd/MM/yyyy', // Eg: Monday 15/12/2025
  SECONDARY: 'dd MMM yyyy', //	Eg: 01 May 2025
  SECONDARY_TIME: 'dd MMM yyyy, hh:mm a', //	Eg: 01 May 2025, 12:00 PM
  WEEKDAY_TIME: 'EEE dd/MM/yyyy, hh:mm a', // Eg: Mon 15/12/2025, 12:00 PM
  DAY_MONTH: 'dd MMM', // Eg: 01 May
  WEEKDAY_TIME_WITH_DAY: 'EEE dd MMM', // Eg: Mon 15 June
  TIME: 'HH:mm:ss',
  HANDSONTABLE_DATE: 'DD/MM/YYYY', // Only used for Handsontable date formatting. Eg: 15/12/2025
  /*
  *****************************************************
    These formats defined below are used only for API requests and not for UI display as they cause issues on Safari browser
   *****************************************************
  */
  STANDARD_DATE: 'yyyy-MM-dd', // Eg: 2025-01-01
  STANDARD_DATE_TIME: "yyyy-MM-dd'T'HH:mm:ss", // Eg: 2025-01-01T12:00:00
  EXPORT_DATE_TIME: 'dd-MM-yy_HH_mm_ss', // Eg: 28-01-26_10_48_22
};

export const EXTENDED_DATE_RANGE_OPTIONS: Array<{
  label: string;
  value: IStaticRangeOption;
}> = [
  { label: 'To Date', value: 'to_date' },
  { label: 'Last 7 days', value: 'last_7' },
  { label: 'Last 15 days', value: 'last_15' },
  { label: 'Last 30 days', value: 'last_30' },
  { label: 'Last 90 days', value: 'last_90' },
  { label: 'Last 180 days', value: 'last_180' },
  { label: 'Custom', value: 'custom' },
];

export const FALLBACK_DATE_FORMATS = [
  'dd/MM/yyyy',
  'yyyy-MM-dd',
  'dd-MM-yyyy',
  'yyyy/MM/dd',
] as const;
